module.exports = __webpack_public_path__ + "img/iso.c38dd2e4.jpg";